import { Link, useNavigate, useParams } from "react-router-dom";
import SideBarWrapper from "../../../components/common/SideBarWrapper";
import Navbar from "../../../layout/Navbar";
import { useEffect, useState } from "react";
import { baseURL } from "../../../utils/misc";
import useAuth from "../../../hooks/useAuth";
import FieldPreparationForm from "../../../components/FieldPreparationRecords/FieldPreparationForm";
import Footer from "../../../layout/Footer";
import { toast } from "react-toastify";

const EditFieldPreparationRecord = () => {
    const { fieldPreparationId } = useParams();
    const [fieldPreparationRecords, setFieldPreparationRecords] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        // Fetch workflow process data when the component mounts
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                }
            };

            try {
                const response = await fetch(`${baseURL}/fieldpreparationrecords/${fieldPreparationId}`, requestOptions);

                if (response.ok) {
                    const data = await response.json();
                    setFieldPreparationRecords(data);
                } else {
                    console.error('Error fetching planting record data');
                }
            } catch (error) {
                console.error('Error fetching planting record data:', error);
            }
        };

        fetchData();
    }, [fieldPreparationId, navigate, user]);




    return (<>

        {/* Page wrapper start */}
        <div className="page-wrapper">

            {/* Sidebar wrapper start */}
            <SideBarWrapper />
            {/* Sidebar wrapper end */}

            {/* Page content start  */}
            <div className="page-content">

                {/* Header start */}
                <Navbar />
                {/* Header end */}

                {/* Page header start */}
                <div className="page-header">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item">{fieldPreparationRecords && fieldPreparationRecords && fieldPreparationRecords.code}</li>
                        <li className="breadcrumb-item">
                            <Link to={`/fieldpreparationrecords/crop/${fieldPreparationRecords && fieldPreparationRecords && fieldPreparationRecords.cropId}`} >Field Preparation Record</Link>
                        </li>
                        <li className="breadcrumb-item active">Edit</li>
                    </ol>
                    <ul className="app-actions">
                    </ul>
                </div>
                {/* Page header end */}

                {/* Main container start */}
                <div className="main-container">
                    <FieldPreparationForm crop={fieldPreparationRecords && fieldPreparationRecords.crop} fieldPreparationRecords={fieldPreparationRecords && fieldPreparationRecords} />
                </div>
                {/* Main container end */}

            </div>
            {/* Page content end */}
            <Footer/>

        </div>
        {/* Page wrapper end */}
    </>);
}

export default EditFieldPreparationRecord;